import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Switch from 'flarum/common/components/Switch';
import Checkbox from 'flarum/common/components/Checkbox';
import { PREF, ALL_DAYS, DISPLAY_DAYS, readPref, savePrefs } from '../utils/preferences';

const t = (key) => app.translator.trans(`happydigital-notification-settings.forum.sleep.${key}`);

const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

/**
 * Sleep mode: a daily quiet window on selected days.
 *
 * Attrs: `user`
 */
export default class SleepSettings extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.loading = null;
  }

  view() {
    const user = this.attrs.user;
    const enabled = !!readPref(user, PREF.sleepEnabled, false);

    return (
      <div>
        <div className="Form-group">
          <Switch
            state={enabled}
            loading={this.loading === 'enabled'}
            onchange={(value) => this.save('enabled', { [PREF.sleepEnabled]: value })}
          >
            {t('enabled_label')}
          </Switch>
          <p className="helpText">{t('enabled_help')}</p>
        </div>
        {enabled ? this.timeFields() : null}
        {enabled ? this.dayFields() : null}
      </div>
    );
  }

  timeFields() {
    const user = this.attrs.user;

    return (
      <div className="Form-group HappyNotify-timeRow">
        {this.timeField('start', PREF.sleepStart, readPref(user, PREF.sleepStart, '23:00'))}
        {this.timeField('end', PREF.sleepEnd, readPref(user, PREF.sleepEnd, '07:00'))}
      </div>
    );
  }

  timeField(name, key, value) {
    return (
      <div className="Form-group">
        <label>{t(`${name}_label`)}</label>
        <input
          className="FormControl"
          type="time"
          value={value}
          disabled={!!this.loading}
          onchange={(e) => {
            if (TIME_PATTERN.test(e.target.value)) this.save(name, { [key]: e.target.value });
          }}
        />
      </div>
    );
  }

  dayFields() {
    const selected = readPref(this.attrs.user, PREF.sleepDays, ALL_DAYS);

    return (
      <div className="Form-group">
        <label>{t('days_label')}</label>
        <div className="HappyNotify-days">
          {DISPLAY_DAYS.map((day) => (
            <Checkbox
              state={selected.includes(day)}
              loading={this.loading === `day${day}`}
              disabled={!!this.loading}
              onchange={(checked) => this.toggleDay(day, checked, selected)}
            >
              {t(`day_${day}`)}
            </Checkbox>
          ))}
        </div>
      </div>
    );
  }

  toggleDay(day, checked, selected) {
    const others = selected.filter((d) => d !== day);
    // Avoid spreading a Set: flarum-webpack-config's loose Babel turns it into [].concat(set).
    const days = (checked ? [...others, day] : others).sort((a, b) => a - b);

    this.save(`day${day}`, { [PREF.sleepDays]: days });
  }

  save(loadingKey, changes) {
    this.loading = loadingKey;

    // The save response carries the refreshed happyNotifyIsQuiet attribute.
    savePrefs(this.attrs.user, changes).finally(() => {
      this.loading = null;
      m.redraw();
    });
  }
}
